import { render, staticRenderFns } from "./LegajoDocuments.vue?vue&type=template&id=7e0c6b3c"
import script from "./LegajoDocuments.vue?vue&type=script&lang=js"
export * from "./LegajoDocuments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tomi/Projects/ingeniAR/rrhh/Frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e0c6b3c')) {
      api.createRecord('7e0c6b3c', component.options)
    } else {
      api.reload('7e0c6b3c', component.options)
    }
    module.hot.accept("./LegajoDocuments.vue?vue&type=template&id=7e0c6b3c", function () {
      api.rerender('7e0c6b3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Legajos/LegajoDocuments.vue"
export default component.exports